import { isSuboptimalBrowser } from "../base/environment/environment";
import { translateToHTML } from "../base/i18n/functions";
import { showWarningNotification } from "../notifications/actions";
import { NOTIFICATION_TIMEOUT_TYPE } from "../notifications/constants";
export * from "./functions.any";
/**
 * Builds the recommended-browsers help URL from the current origin and fixed path,
 * validates http(s), and escapes HTML so interpolation into translated HTML is safe.
 *
 * @returns {string}
 */
function getSafeRecommendedBrowserPageLink() {
    let href;
    try {
        const parsed = new URL("/static/recommendedBrowsers.html", window.location.origin);
        if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
            href = "/static/recommendedBrowsers.html";
        }
        else {
            href = parsed.href;
        }
    }
    catch {
        href = "/static/recommendedBrowsers.html";
    }
    return href
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
}
/**
 * Shows the suboptimal experience notification if needed.
 *
 * @param {Function} dispatch - The dispatch method.
 * @param {Function} t - The translation function.
 * @returns {void}
 */
export function maybeShowSuboptimalExperienceNotification(dispatch, t) {
    if (isSuboptimalBrowser()) {
        dispatch(showWarningNotification({
            titleKey: "notify.suboptimalExperienceTitle",
            description: translateToHTML(t, "notify.suboptimalBrowserWarning", {
                recommendedBrowserPageLink: getSafeRecommendedBrowserPageLink(),
            }),
        }, NOTIFICATION_TIMEOUT_TYPE.LONG));
    }
}
